var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPressGoogle = function SvgPressGoogle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 269.64,
    height: 88.76,
    viewBox: "0 0 269.64 88.76",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1584",
    "data-name": "Group 1584",
    transform: "translate(-1007 -18435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-logo",
    transform: "translate(1006.64 18434.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M115.75,47.18a22.25,22.25,0,0,1-44.5,0,22.25,22.25,0,0,1,44.5,0Zm-9.74,0c0-7.98-5.79-13.44-12.51-13.44S80.99,39.2,80.99,47.18c0,7.9,5.79,13.44,12.51,13.44S106.01,55.07,106.01,47.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M163.75,47.18a22.25,22.25,0,0,1-44.5,0,22.25,22.25,0,0,1,44.5,0Zm-9.74,0c0-7.98-5.79-13.44-12.51-13.44s-12.51,5.46-12.51,13.44c0,7.9,5.79,13.44,12.51,13.44S154.01,55.07,154.01,47.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M209.75,26.34V66.16c0,16.38-9.66,23.07-21.08,23.07a21.122,21.122,0,0,1-19.66-13.07l8.48-3.53c1.51,3.61,5.21,7.87,11.17,7.87,7.31,0,11.84-4.51,11.84-13V64.31h-.34a15.1,15.1,0,0,1-11.68,5.04c-11.09,0-21.25-9.66-21.25-22.09,0-12.52,10.16-22.26,21.25-22.26a15.37,15.37,0,0,1,11.68,4.96h.34V26.35h9.25Zm-8.56,20.92c0-7.81-5.21-13.52-11.84-13.52-6.72,0-12.35,5.71-12.35,13.52,0,7.73,5.63,13.36,12.35,13.36C195.98,60.62,201.19,54.99,201.19,47.26Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M225,3V68h-9.5V3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M262.02,54.48l7.56,5.04a22.077,22.077,0,0,1-18.48,9.83c-12.6,0-22.01-9.74-22.01-22.18,0-13.19,9.49-22.18,20.92-22.18,11.51,0,17.14,9.16,18.98,14.11L270,41.62,240.35,53.9c2.27,4.45,5.8,6.72,10.75,6.72s8.4-2.44,10.92-6.14ZM238.75,46.5l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7A12.166,12.166,0,0,0,238.75,46.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M35.29,41.41V32H67a31.179,31.179,0,0,1,.47,5.68c0,7.06-1.93,15.79-8.15,22.01-6.05,6.3-13.78,9.66-24.02,9.66C16.32,69.35.36,53.89.36,34.91S16.32.47,35.3.47A32.817,32.817,0,0,1,58.9,9.96L52.26,16.6A23.986,23.986,0,0,0,35.29,9.88a24.7,24.7,0,0,0-24.7,25.03,24.7,24.7,0,0,0,24.7,25.03c8.99,0,14.11-3.61,17.39-6.89,2.66-2.66,4.41-6.46,5.1-11.65Z",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPressGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/press-google.889ca2b48ec2a6e2f4a3627a920e3b0b.svg";